/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Tabs } from 'antd-mobile'
import { TabWrap, TabTxt, Point } from '@styles/base.style'
import { observer } from 'mobx-react'
import { Models } from 'rmc-tabs/lib/Models'
import { Select } from 'antd'
// import { isNumber } from 'lodash'
import useRootStore from '@store/useRootStore'
import { UpIco } from '@shared/Icon/ArrowIcon'
import { ListHeaderWrap } from '../PickList/index.style'
import PickList from '../PickList'

// css
const { Option } = Select
const Up = (
  <span className="up-ico">
    <UpIco />
  </span>
)

function getListHeader(index: number, total: number, currentFilter: number, onChange: (value: string) => void) {
  let titleEle
  if (index === 0) {
    titleEle = (
      <h2 className="list-header-tit">
        현재 <Point primary>{total}</Point>개의 픽이 판매중
      </h2>
    )
  } else if (index === 1) {
    titleEle = (
      <h2 className="list-header-tit">
        내가 판매한 픽 총 <Point primary>{total}</Point>개
      </h2>
    )
  } else if (index === 2) {
    titleEle = (
      <h2 className="list-header-tit">
        내가 구매한 픽 총 <Point primary>{total}</Point>개
      </h2>
    )
  }
  return (
    <ListHeaderWrap>
      {titleEle}
      {Up}
      <Select defaultValue={currentFilter.toString()} onChange={onChange}>
        <Option value="0">
          <span className="option-txt">등록시간</span>
        </Option>
        <Option value="1">
          <span className="option-txt">마감시간</span>
        </Option>
        <Option value="2">
          <span className="option-txt">판매수</span>
        </Option>
        <Option value="3">
          <span className="option-txt">가격</span>
        </Option>
        <Option value="4">
          <span className="option-txt">배당률</span>
        </Option>
        <Option value="5">
          <span className="option-txt">폴드 수</span>
        </Option>
      </Select>
    </ListHeaderWrap>
  )
}

const bettingTab = [
  { title: <TabTxt>픽거래소</TabTxt>, key: '0' },
  { title: <TabTxt>내가 판매한 픽</TabTxt>, key: '1' },
  { title: <TabTxt>내가 구매한 픽</TabTxt>, key: '2' },
]

const PickTab: React.FC = props => {
  const { pickStore } = useRootStore()
  const { tab, filter, fetchIndex } = pickStore
  const currentSource = pickStore.getSource(fetchIndex)
  const total = currentSource ? currentSource.total : undefined

  const handleFilterChange = (value: string) => {
    // message.info(`filter changed ${value}`)
    pickStore.setFilter(Number(value))
  }

  // let eleHeader
  // if (isNumber(total) === true) {
  //   eleHeader = getListHeader(tab, total, filter, handleFilterChange)
  // }

  const tabChanged = (t: Models.TabData, index: number) => {
    pickStore.setTab(index)
  }

  // const contents = []

  // let index = 0
  // for (const el of bettingTab) {
  //   contents.push(
  //     <ContentWrap key={el.key} style={{ marginTop: 0, padding: 0 }}>
  //       <Content>
  //         <PickList currentIndex={tab} currentFilter={filter} index={tab} />
  //       </Content>
  //     </ContentWrap>,
  //   )
  //   // index += 1
  // }

  return (
    <Fragment>
      <TabWrap>
        <Tabs tabs={bettingTab} initialPage={tab} page={tab} onChange={tabChanged} />
      </TabWrap>

      {getListHeader(tab, total, filter, handleFilterChange)}

      <TabWrap>
        <Tabs tabs={bettingTab} initialPage={tab} page={tab} renderTabBar={false} onChange={tabChanged} />
      </TabWrap>
      <PickList currentIndex={tab} currentFilter={filter} />
    </Fragment>
  )
}

export default observer(PickTab)
